import React, { useState } from 'react'
import { ITheme } from 'application/utils/type'
import { CheckBoxStyled } from '../../styledComponents/checkBoxStyled/checkBoxStyled'
import * as E from './checklistCardElements'
import { ICardChecklistItemProps } from './proposalInterfaces/cardCheckListItemProps'

interface ICardChecklistRenderedItemProps {
  item: ICardChecklistItemProps
  cardNumber: number
  UpdateChecked(id: string, isChecked: boolean, cardNumber: number): any
  errorList: any[]
  showIds: boolean
  theme: ITheme
}

const CardChecklistItem = (props: ICardChecklistRenderedItemProps) => {
  const [isChecked, setIsChecked] = useState(props.item.isChecked)

  const handleChange = (isChecked: boolean, id: string, cardNumber: number) => {
    setIsChecked(isChecked)
    props.UpdateChecked(id, isChecked, cardNumber)
  }

  return (
    <E.CheckItemContainer>
      <span
        onClick={() =>
          handleChange(!isChecked, props.item.id, props.cardNumber)
        }
        id={props.item.id}
      >
        <CheckBoxStyled
          active={isChecked}
          error={
            !isChecked &&
            props.errorList.find(
              (err) =>
                err.cardNumber === props.cardNumber && err.id === props.item.id
            )
          }
        />
      </span>

      <E.CheckListItem>
        {props.showIds && (
          <E.ItemNumber htmlFor={props.item.id}>
            {props.item.id.toString().includes('.')
              ? props.item.id
              : props.item.id.toString() + '.'}
          </E.ItemNumber>
        )}
        <E.CheckListText
          htmlFor={props.item.id}
          dangerouslySetInnerHTML={{ __html: props.item.text }}
          theme={props.theme}
        ></E.CheckListText>
      </E.CheckListItem>
    </E.CheckItemContainer>
  )
}

export default CardChecklistItem
